'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/axios/lib/cancel/isCancel.js
// module id = 476
// module chunks = 168707334958949